// note: need to use global moment instance to access correct current locale
// Locale gets set in zf/frontend/vcom/LanguageSwitch.js on makeMoment instance
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
const makeMoment = moment;
export default makeMoment;
